import { render, staticRenderFns } from "./Map.vue?vue&type=template&id=54874852&lang=pug"
import script from "./Map.vue?vue&type=script&lang=coffee"
export * from "./Map.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports